const data = {
  id: 1,
  title: 'Listen and choose the correct sound.',
  subTitle: 'Nghe và chọn âm xuất hiện trong từ.',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/efbbb634-1558-4ec6-bd9e-915bdcd0eddf.mp3',
  answers: [
    { id: 1, answer: 'ch', isCorrect: false },
    { id: 2, answer: 'sh', isCorrect: true },
    { id: 3, answer: 'th', isCorrect: false },
  ],
  settings: {
    answers: {
      direction: 'horizontal',
      bulletType: 'none',
      // bulletType: 'character',
      // bulletType: 'number',
    },
  },
};

export default data;
